export default {
    syear: 115,
}